import React from "react";
import style from "css/landing.module.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

function DeviceItem(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <Link
      to={`${process.env.REACT_APP_CLIENT_URL + props.tech.link}`}
      className={`${style.technology_list_item} ${style[props.type]}`}
    >
      <div
        className={style.technology_list_item_title}
        dangerouslySetInnerHTML={{ __html: props.tech.title }}
      ></div>
      <img
        alt=""
        src={
          !isMobile && !isTablet
            ? `${process.env.REACT_APP_CLIENT_URL + props.tech.img}`
            : `${process.env.REACT_APP_CLIENT_URL + props.tech.img_m}`
        }
      />
    </Link>
  );
}

export default DeviceItem;
